import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AudakoEntitySelectExplorerComponent } from './components/audako-entity-select/audako-entity-select-explorer/audako-entity-select-explorer.component';
import { AudakoEntitySelectSideBarComponent } from './components/audako-entity-select/audako-entity-select-side-bar/audako-entity-select-side-bar.component';
import { AudakoEntitySelectComponent } from './components/audako-entity-select/audako-entity-select.component';
import { ConfigurationEntityPathPipe } from './pipes/configuration-entity-path.pipe';
import { PathPipe } from './pipes/path.pipe';
import { ConfigReferencesComponent } from './components/references/references.component';
import { ConfigurationEntityNamePipe } from '@shared/pipes/configuration-entity-name.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IconModule } from '@core/components/icon/icon.module';
import { BlockScrollStrategy, Overlay } from '@angular/cdk/overlay';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { NumberinputDirective } from './directives/numberinput.directive';
import { TranslationModule } from '@core/modules/translation/translation.module';
import { EntryComponent } from '@shared/components/entry/entry.component';
import { ConfirmModalComponent } from './components/confirm-modal/confirm-modal.component';
import { SkeletonComponent } from '@shared/components/skeleton/skeleton.component';
import { InvitationFeedListModule } from '@core/components/invitation-feed-list/invitation-feed-list.module';
import { RouterModule } from '@angular/router';
import { SkeletonMenuComponent } from './components/skeleton/skeleton-menu/skeleton-menu.component';
import { SkeletonHeaderContentComponent } from './components/skeleton/skeleton-header-content/skeleton-header-content.component';
import { SkeletonContentComponent } from './components/skeleton/skeleton-content/skeleton-content.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatBadgeModule } from '@angular/material/badge';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTreeModule } from '@angular/material/tree';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { GermanDecimalPipe } from '@shared/pipes/german-decimal/german-decimal.pipe';
import { AutoFocusDirective } from '@shared/directives/auto-focus.directive';
import { CollapseDirective } from '@shared/directives/collapse.directive';
import { SafePipe } from '@shared/pipes/safe.pipe';
import { FieldPipe } from '@shared/pipes/field.pipe';
import { EntityListModule } from '@shared/modules/entity-list/entity-list.module';
import { SpinnerModule } from '@core/components/spinner/spinner.module';
import { TableModule } from './components/table/table.module';
import { FilterModule } from './modules/filter/filter.module';

import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { SimpleFilterComponent } from '@shared/modals/simple-filter.component';
import { HumanReadableDatePipe } from './pipes/human-readable-date.pipe';

export function scrollFactory(overlay: Overlay): () => BlockScrollStrategy {
  return () => overlay.scrollStrategies.block();
}

@NgModule({
  imports: [
    // Angular
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,

    // Extern
    ScrollingModule,

    // Intern
    TranslationModule,
    IconModule,
    InvitationFeedListModule,
    EntityListModule,

    // Angular Material
    MatDialogModule,
    MatButtonModule,
    MatInputModule,
    MatAutocompleteModule,
    MatToolbarModule,
    MatBadgeModule,
    MatIconModule,
    MatCardModule,
    MatSlideToggleModule,
    MatTableModule,
    MatCheckboxModule,
    MatSortModule,
    MatPaginatorModule,
    MatTreeModule,
    MatSidenavModule,
    MatMenuModule,
    MatDividerModule,
    SpinnerModule,
    TableModule,
    FilterModule,
    MatListModule,
    MatSelectModule
  ],
  declarations: [
    // Components
    AudakoEntitySelectComponent,
    AudakoEntitySelectSideBarComponent,
    AudakoEntitySelectExplorerComponent,
    EntryComponent,
    ConfigReferencesComponent,
    ConfirmModalComponent,
    SkeletonComponent,
    SkeletonMenuComponent,
    SkeletonHeaderContentComponent,
    SkeletonContentComponent,

    // Directives
    CollapseDirective,
    NumberinputDirective,
    AutoFocusDirective,

    // Pipes
    ConfigurationEntityPathPipe,
    ConfigurationEntityNamePipe,
    PathPipe,
    GermanDecimalPipe,
    SafePipe,
    FieldPipe,
    SimpleFilterComponent,
    HumanReadableDatePipe
  ],
  providers: [],
  exports: [
    // Components
    AudakoEntitySelectComponent,
    ConfigReferencesComponent,
    EntryComponent,
    SkeletonComponent,
    SkeletonMenuComponent,
    SkeletonHeaderContentComponent,
    SkeletonContentComponent,

    // Modules
    IconModule,

    // Directives
    CollapseDirective,
    NumberinputDirective,
    AutoFocusDirective,

    // Pipes
    ConfigurationEntityPathPipe,
    ConfigurationEntityNamePipe,
    PathPipe,
    GermanDecimalPipe,
    SafePipe,
    FieldPipe,
    SimpleFilterComponent,
    HumanReadableDatePipe
  ],
})
export class SharedModule {}
